// frontend/src/api/apiClient.js
import axios from 'axios';
import authService from '../services/authService';

const BASE_API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
const API_URL = `${BASE_API_URL}/api/v1`;

const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    error ? prom.reject(error) : prom.resolve(token);
  });
  failedQueue = [];
};

const publicPaths = [
  '/products/categories',
  '/products/main-categories',
  '/products/latest',
  '/products/list',
  '/products/search',
  '/products/tags',
  '/books',
  '/profile/daily-message',
  '/health',
  '/auth/register',
  '/auth/login',
  '/auth/token/refresh',
  '/token/refresh',
   '/auth/password-reset/request',   // ← اضافه کن
  '/auth/password-reset/confirm', 
];

apiClient.interceptors.request.use(
  (config) => {
    const urlPath = (config.url || '').replace(/^\//, '');
    const isPublic = publicPaths.some(path => {
      const cleanPath = path.replace(/^\//, '');
      return urlPath === cleanPath || urlPath.startsWith(cleanPath + '/');
    });

    if (!isPublic) {
      let token = authService.getAuthTokens();
      // اگر توکن به صورت object برگشت (مثلاً {access: '...'})، آن را استخراج کن
      if (token && typeof token === 'object' && token.access) {
        token = token.access;
      }
      if (token && typeof token === 'string') {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    }

    console.log('📡 REQUEST:', config.method?.toUpperCase(), config.url,
      'Token:', config.headers?.Authorization ? 'YES' : 'NO');
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      if (originalRequest.url.includes('/token/refresh/') || originalRequest.url.includes('/auth/token/refresh/')) {
        authService.clearAuthData();
        return Promise.reject(error);
      }
      originalRequest._retry = true;
      if (!isRefreshing) {
        isRefreshing = true;
        const refreshToken = localStorage.getItem('refresh_token') || sessionStorage.getItem('refresh_token');
        if (!refreshToken) {
          authService.clearAuthData();
          isRefreshing = false;
          return Promise.reject(error);
        }
        try {
          let res;
          try {
            res = await axios.post(`${API_URL}/auth/token/refresh/`, { refresh: refreshToken });
          } catch {
            res = await axios.post(`${API_URL}/token/refresh/`, { refresh: refreshToken });
          }
          const newAccess = res.data.access;
          authService.setAuthData({ token: newAccess, refresh_token: refreshToken });
          originalRequest.headers['Authorization'] = `Bearer ${newAccess}`;
          processQueue(null, newAccess);
          isRefreshing = false;
          return apiClient(originalRequest);
        } catch (err) {
          authService.clearAuthData();
          processQueue(err, null);
          isRefreshing = false;
          return Promise.reject(err);
        }
      }
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      }).then(token => {
        originalRequest.headers['Authorization'] = `Bearer ${token}`;
        return apiClient(originalRequest);
      }).catch(err => Promise.reject(err));
    }
    return Promise.reject(error);
  }
);

export default apiClient;